module.exports = __webpack_public_path__ + "img/zx_fof.ce3c2fb2.png";